/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as publicPricingRouteImport } from './routes/(public)/pricing'
import { Route as publicDemoRouteImport } from './routes/(public)/demo'
import { Route as publicChangelogRouteImport } from './routes/(public)/changelog'
import { Route as publicSplatRouteImport } from './routes/(public)/$splat'
import { Route as authRegisterRouteImport } from './routes/(auth)/register'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard'
import { Route as appBillingRouteImport } from './routes/(app)/billing'
import { Route as appSettingsIndexRouteImport } from './routes/(app)/settings/index'
import { Route as appAdminIndexRouteImport } from './routes/(app)/admin/index'
import { Route as dashboardBillingSuccessRouteImport } from './routes/(dashboard)/billing.success'
import { Route as dashboardBillingCancelRouteImport } from './routes/(dashboard)/billing.cancel'
import { Route as appSettingsUsageRouteImport } from './routes/(app)/settings/usage'
import { Route as appSettingsSecurityRouteImport } from './routes/(app)/settings/security'
import { Route as appSettingsProfileRouteImport } from './routes/(app)/settings/profile'
import { Route as appSettingsPrivacyRouteImport } from './routes/(app)/settings/privacy'
import { Route as appSettingsPreferencesRouteImport } from './routes/(app)/settings/preferences'
import { Route as appSettingsNotificationsRouteImport } from './routes/(app)/settings/notifications'
import { Route as appSettingsLoginHistoryRouteImport } from './routes/(app)/settings/login-history'
import { Route as appSettingsConnectedAccountsRouteImport } from './routes/(app)/settings/connected-accounts'
import { Route as appSettingsApiKeysRouteImport } from './routes/(app)/settings/api-keys'
import { Route as appAdminUsersRouteImport } from './routes/(app)/admin/users'
import { Route as appAdminSettingsRouteImport } from './routes/(app)/admin/settings'
import { Route as appAdminHealthRouteImport } from './routes/(app)/admin/health'
import { Route as appAdminFeatureFlagsRouteImport } from './routes/(app)/admin/feature-flags'
import { Route as appAdminEmailTemplatesRouteImport } from './routes/(app)/admin/email-templates'
import { Route as appAdminAuditLogsRouteImport } from './routes/(app)/admin/audit-logs'
import { Route as appAdminAnnouncementsRouteImport } from './routes/(app)/admin/announcements'
import { Route as appOrgOrgSlugTeamRouteImport } from './routes/(app)/org/$orgSlug/team'
import { Route as appOrgOrgSlugSettingsRouteImport } from './routes/(app)/org/$orgSlug/settings'
import { Route as appOrgOrgSlugBillingRouteImport } from './routes/(app)/org/$orgSlug/billing'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const publicPricingRoute = publicPricingRouteImport.update({
  id: '/(public)/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const publicDemoRoute = publicDemoRouteImport.update({
  id: '/(public)/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const publicChangelogRoute = publicChangelogRouteImport.update({
  id: '/(public)/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const publicSplatRoute = publicSplatRouteImport.update({
  id: '/(public)/$splat',
  path: '/$splat',
  getParentRoute: () => rootRouteImport,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const appDashboardRoute = appDashboardRouteImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const appBillingRoute = appBillingRouteImport.update({
  id: '/(app)/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsIndexRoute = appSettingsIndexRouteImport.update({
  id: '/(app)/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminIndexRoute = appAdminIndexRouteImport.update({
  id: '/(app)/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardBillingSuccessRoute = dashboardBillingSuccessRouteImport.update({
  id: '/(dashboard)/billing/success',
  path: '/billing/success',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardBillingCancelRoute = dashboardBillingCancelRouteImport.update({
  id: '/(dashboard)/billing/cancel',
  path: '/billing/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsUsageRoute = appSettingsUsageRouteImport.update({
  id: '/(app)/settings/usage',
  path: '/settings/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsSecurityRoute = appSettingsSecurityRouteImport.update({
  id: '/(app)/settings/security',
  path: '/settings/security',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsProfileRoute = appSettingsProfileRouteImport.update({
  id: '/(app)/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsPrivacyRoute = appSettingsPrivacyRouteImport.update({
  id: '/(app)/settings/privacy',
  path: '/settings/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsPreferencesRoute = appSettingsPreferencesRouteImport.update({
  id: '/(app)/settings/preferences',
  path: '/settings/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsNotificationsRoute =
  appSettingsNotificationsRouteImport.update({
    id: '/(app)/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => rootRouteImport,
  } as any)
const appSettingsLoginHistoryRoute = appSettingsLoginHistoryRouteImport.update({
  id: '/(app)/settings/login-history',
  path: '/settings/login-history',
  getParentRoute: () => rootRouteImport,
} as any)
const appSettingsConnectedAccountsRoute =
  appSettingsConnectedAccountsRouteImport.update({
    id: '/(app)/settings/connected-accounts',
    path: '/settings/connected-accounts',
    getParentRoute: () => rootRouteImport,
  } as any)
const appSettingsApiKeysRoute = appSettingsApiKeysRouteImport.update({
  id: '/(app)/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminUsersRoute = appAdminUsersRouteImport.update({
  id: '/(app)/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminSettingsRoute = appAdminSettingsRouteImport.update({
  id: '/(app)/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminHealthRoute = appAdminHealthRouteImport.update({
  id: '/(app)/admin/health',
  path: '/admin/health',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminFeatureFlagsRoute = appAdminFeatureFlagsRouteImport.update({
  id: '/(app)/admin/feature-flags',
  path: '/admin/feature-flags',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminEmailTemplatesRoute = appAdminEmailTemplatesRouteImport.update({
  id: '/(app)/admin/email-templates',
  path: '/admin/email-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminAuditLogsRoute = appAdminAuditLogsRouteImport.update({
  id: '/(app)/admin/audit-logs',
  path: '/admin/audit-logs',
  getParentRoute: () => rootRouteImport,
} as any)
const appAdminAnnouncementsRoute = appAdminAnnouncementsRouteImport.update({
  id: '/(app)/admin/announcements',
  path: '/admin/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const appOrgOrgSlugTeamRoute = appOrgOrgSlugTeamRouteImport.update({
  id: '/(app)/org/$orgSlug/team',
  path: '/org/$orgSlug/team',
  getParentRoute: () => rootRouteImport,
} as any)
const appOrgOrgSlugSettingsRoute = appOrgOrgSlugSettingsRouteImport.update({
  id: '/(app)/org/$orgSlug/settings',
  path: '/org/$orgSlug/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const appOrgOrgSlugBillingRoute = appOrgOrgSlugBillingRouteImport.update({
  id: '/(app)/org/$orgSlug/billing',
  path: '/org/$orgSlug/billing',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/billing': typeof appBillingRoute
  '/dashboard': typeof appDashboardRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/$splat': typeof publicSplatRoute
  '/changelog': typeof publicChangelogRoute
  '/demo': typeof publicDemoRoute
  '/pricing': typeof publicPricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/announcements': typeof appAdminAnnouncementsRoute
  '/admin/audit-logs': typeof appAdminAuditLogsRoute
  '/admin/email-templates': typeof appAdminEmailTemplatesRoute
  '/admin/feature-flags': typeof appAdminFeatureFlagsRoute
  '/admin/health': typeof appAdminHealthRoute
  '/admin/settings': typeof appAdminSettingsRoute
  '/admin/users': typeof appAdminUsersRoute
  '/settings/api-keys': typeof appSettingsApiKeysRoute
  '/settings/connected-accounts': typeof appSettingsConnectedAccountsRoute
  '/settings/login-history': typeof appSettingsLoginHistoryRoute
  '/settings/notifications': typeof appSettingsNotificationsRoute
  '/settings/preferences': typeof appSettingsPreferencesRoute
  '/settings/privacy': typeof appSettingsPrivacyRoute
  '/settings/profile': typeof appSettingsProfileRoute
  '/settings/security': typeof appSettingsSecurityRoute
  '/settings/usage': typeof appSettingsUsageRoute
  '/billing/cancel': typeof dashboardBillingCancelRoute
  '/billing/success': typeof dashboardBillingSuccessRoute
  '/admin': typeof appAdminIndexRoute
  '/settings': typeof appSettingsIndexRoute
  '/org/$orgSlug/billing': typeof appOrgOrgSlugBillingRoute
  '/org/$orgSlug/settings': typeof appOrgOrgSlugSettingsRoute
  '/org/$orgSlug/team': typeof appOrgOrgSlugTeamRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/billing': typeof appBillingRoute
  '/dashboard': typeof appDashboardRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/$splat': typeof publicSplatRoute
  '/changelog': typeof publicChangelogRoute
  '/demo': typeof publicDemoRoute
  '/pricing': typeof publicPricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/announcements': typeof appAdminAnnouncementsRoute
  '/admin/audit-logs': typeof appAdminAuditLogsRoute
  '/admin/email-templates': typeof appAdminEmailTemplatesRoute
  '/admin/feature-flags': typeof appAdminFeatureFlagsRoute
  '/admin/health': typeof appAdminHealthRoute
  '/admin/settings': typeof appAdminSettingsRoute
  '/admin/users': typeof appAdminUsersRoute
  '/settings/api-keys': typeof appSettingsApiKeysRoute
  '/settings/connected-accounts': typeof appSettingsConnectedAccountsRoute
  '/settings/login-history': typeof appSettingsLoginHistoryRoute
  '/settings/notifications': typeof appSettingsNotificationsRoute
  '/settings/preferences': typeof appSettingsPreferencesRoute
  '/settings/privacy': typeof appSettingsPrivacyRoute
  '/settings/profile': typeof appSettingsProfileRoute
  '/settings/security': typeof appSettingsSecurityRoute
  '/settings/usage': typeof appSettingsUsageRoute
  '/billing/cancel': typeof dashboardBillingCancelRoute
  '/billing/success': typeof dashboardBillingSuccessRoute
  '/admin': typeof appAdminIndexRoute
  '/settings': typeof appSettingsIndexRoute
  '/org/$orgSlug/billing': typeof appOrgOrgSlugBillingRoute
  '/org/$orgSlug/settings': typeof appOrgOrgSlugSettingsRoute
  '/org/$orgSlug/team': typeof appOrgOrgSlugTeamRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)/billing': typeof appBillingRoute
  '/(app)/dashboard': typeof appDashboardRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(public)/$splat': typeof publicSplatRoute
  '/(public)/changelog': typeof publicChangelogRoute
  '/(public)/demo': typeof publicDemoRoute
  '/(public)/pricing': typeof publicPricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/(app)/admin/announcements': typeof appAdminAnnouncementsRoute
  '/(app)/admin/audit-logs': typeof appAdminAuditLogsRoute
  '/(app)/admin/email-templates': typeof appAdminEmailTemplatesRoute
  '/(app)/admin/feature-flags': typeof appAdminFeatureFlagsRoute
  '/(app)/admin/health': typeof appAdminHealthRoute
  '/(app)/admin/settings': typeof appAdminSettingsRoute
  '/(app)/admin/users': typeof appAdminUsersRoute
  '/(app)/settings/api-keys': typeof appSettingsApiKeysRoute
  '/(app)/settings/connected-accounts': typeof appSettingsConnectedAccountsRoute
  '/(app)/settings/login-history': typeof appSettingsLoginHistoryRoute
  '/(app)/settings/notifications': typeof appSettingsNotificationsRoute
  '/(app)/settings/preferences': typeof appSettingsPreferencesRoute
  '/(app)/settings/privacy': typeof appSettingsPrivacyRoute
  '/(app)/settings/profile': typeof appSettingsProfileRoute
  '/(app)/settings/security': typeof appSettingsSecurityRoute
  '/(app)/settings/usage': typeof appSettingsUsageRoute
  '/(dashboard)/billing/cancel': typeof dashboardBillingCancelRoute
  '/(dashboard)/billing/success': typeof dashboardBillingSuccessRoute
  '/(app)/admin/': typeof appAdminIndexRoute
  '/(app)/settings/': typeof appSettingsIndexRoute
  '/(app)/org/$orgSlug/billing': typeof appOrgOrgSlugBillingRoute
  '/(app)/org/$orgSlug/settings': typeof appOrgOrgSlugSettingsRoute
  '/(app)/org/$orgSlug/team': typeof appOrgOrgSlugTeamRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/$splat'
    | '/changelog'
    | '/demo'
    | '/pricing'
    | '/auth/callback'
    | '/admin/announcements'
    | '/admin/audit-logs'
    | '/admin/email-templates'
    | '/admin/feature-flags'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/users'
    | '/settings/api-keys'
    | '/settings/connected-accounts'
    | '/settings/login-history'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/usage'
    | '/billing/cancel'
    | '/billing/success'
    | '/admin'
    | '/settings'
    | '/org/$orgSlug/billing'
    | '/org/$orgSlug/settings'
    | '/org/$orgSlug/team'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/billing'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/$splat'
    | '/changelog'
    | '/demo'
    | '/pricing'
    | '/auth/callback'
    | '/admin/announcements'
    | '/admin/audit-logs'
    | '/admin/email-templates'
    | '/admin/feature-flags'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/users'
    | '/settings/api-keys'
    | '/settings/connected-accounts'
    | '/settings/login-history'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/usage'
    | '/billing/cancel'
    | '/billing/success'
    | '/admin'
    | '/settings'
    | '/org/$orgSlug/billing'
    | '/org/$orgSlug/settings'
    | '/org/$orgSlug/team'
  id:
    | '__root__'
    | '/'
    | '/(app)/billing'
    | '/(app)/dashboard'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(public)/$splat'
    | '/(public)/changelog'
    | '/(public)/demo'
    | '/(public)/pricing'
    | '/auth/callback'
    | '/(app)/admin/announcements'
    | '/(app)/admin/audit-logs'
    | '/(app)/admin/email-templates'
    | '/(app)/admin/feature-flags'
    | '/(app)/admin/health'
    | '/(app)/admin/settings'
    | '/(app)/admin/users'
    | '/(app)/settings/api-keys'
    | '/(app)/settings/connected-accounts'
    | '/(app)/settings/login-history'
    | '/(app)/settings/notifications'
    | '/(app)/settings/preferences'
    | '/(app)/settings/privacy'
    | '/(app)/settings/profile'
    | '/(app)/settings/security'
    | '/(app)/settings/usage'
    | '/(dashboard)/billing/cancel'
    | '/(dashboard)/billing/success'
    | '/(app)/admin/'
    | '/(app)/settings/'
    | '/(app)/org/$orgSlug/billing'
    | '/(app)/org/$orgSlug/settings'
    | '/(app)/org/$orgSlug/team'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appBillingRoute: typeof appBillingRoute
  appDashboardRoute: typeof appDashboardRoute
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  publicSplatRoute: typeof publicSplatRoute
  publicChangelogRoute: typeof publicChangelogRoute
  publicDemoRoute: typeof publicDemoRoute
  publicPricingRoute: typeof publicPricingRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  appAdminAnnouncementsRoute: typeof appAdminAnnouncementsRoute
  appAdminAuditLogsRoute: typeof appAdminAuditLogsRoute
  appAdminEmailTemplatesRoute: typeof appAdminEmailTemplatesRoute
  appAdminFeatureFlagsRoute: typeof appAdminFeatureFlagsRoute
  appAdminHealthRoute: typeof appAdminHealthRoute
  appAdminSettingsRoute: typeof appAdminSettingsRoute
  appAdminUsersRoute: typeof appAdminUsersRoute
  appSettingsApiKeysRoute: typeof appSettingsApiKeysRoute
  appSettingsConnectedAccountsRoute: typeof appSettingsConnectedAccountsRoute
  appSettingsLoginHistoryRoute: typeof appSettingsLoginHistoryRoute
  appSettingsNotificationsRoute: typeof appSettingsNotificationsRoute
  appSettingsPreferencesRoute: typeof appSettingsPreferencesRoute
  appSettingsPrivacyRoute: typeof appSettingsPrivacyRoute
  appSettingsProfileRoute: typeof appSettingsProfileRoute
  appSettingsSecurityRoute: typeof appSettingsSecurityRoute
  appSettingsUsageRoute: typeof appSettingsUsageRoute
  dashboardBillingCancelRoute: typeof dashboardBillingCancelRoute
  dashboardBillingSuccessRoute: typeof dashboardBillingSuccessRoute
  appAdminIndexRoute: typeof appAdminIndexRoute
  appSettingsIndexRoute: typeof appSettingsIndexRoute
  appOrgOrgSlugBillingRoute: typeof appOrgOrgSlugBillingRoute
  appOrgOrgSlugSettingsRoute: typeof appOrgOrgSlugSettingsRoute
  appOrgOrgSlugTeamRoute: typeof appOrgOrgSlugTeamRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/pricing': {
      id: '/(public)/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof publicPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/demo': {
      id: '/(public)/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof publicDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/changelog': {
      id: '/(public)/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof publicChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/$splat': {
      id: '/(public)/$splat'
      path: '/$splat'
      fullPath: '/$splat'
      preLoaderRoute: typeof publicSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/billing': {
      id: '/(app)/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof appBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/': {
      id: '/(app)/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/': {
      id: '/(app)/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof appAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/billing/success': {
      id: '/(dashboard)/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof dashboardBillingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/billing/cancel': {
      id: '/(dashboard)/billing/cancel'
      path: '/billing/cancel'
      fullPath: '/billing/cancel'
      preLoaderRoute: typeof dashboardBillingCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/usage': {
      id: '/(app)/settings/usage'
      path: '/settings/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof appSettingsUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/security': {
      id: '/(app)/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof appSettingsSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/profile': {
      id: '/(app)/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof appSettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/privacy': {
      id: '/(app)/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof appSettingsPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/preferences': {
      id: '/(app)/settings/preferences'
      path: '/settings/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof appSettingsPreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/notifications': {
      id: '/(app)/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof appSettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/login-history': {
      id: '/(app)/settings/login-history'
      path: '/settings/login-history'
      fullPath: '/settings/login-history'
      preLoaderRoute: typeof appSettingsLoginHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/connected-accounts': {
      id: '/(app)/settings/connected-accounts'
      path: '/settings/connected-accounts'
      fullPath: '/settings/connected-accounts'
      preLoaderRoute: typeof appSettingsConnectedAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/settings/api-keys': {
      id: '/(app)/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof appSettingsApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/users': {
      id: '/(app)/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof appAdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/settings': {
      id: '/(app)/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof appAdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/health': {
      id: '/(app)/admin/health'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof appAdminHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/feature-flags': {
      id: '/(app)/admin/feature-flags'
      path: '/admin/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof appAdminFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/email-templates': {
      id: '/(app)/admin/email-templates'
      path: '/admin/email-templates'
      fullPath: '/admin/email-templates'
      preLoaderRoute: typeof appAdminEmailTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/audit-logs': {
      id: '/(app)/admin/audit-logs'
      path: '/admin/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof appAdminAuditLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/admin/announcements': {
      id: '/(app)/admin/announcements'
      path: '/admin/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof appAdminAnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$orgSlug/team': {
      id: '/(app)/org/$orgSlug/team'
      path: '/org/$orgSlug/team'
      fullPath: '/org/$orgSlug/team'
      preLoaderRoute: typeof appOrgOrgSlugTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$orgSlug/settings': {
      id: '/(app)/org/$orgSlug/settings'
      path: '/org/$orgSlug/settings'
      fullPath: '/org/$orgSlug/settings'
      preLoaderRoute: typeof appOrgOrgSlugSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$orgSlug/billing': {
      id: '/(app)/org/$orgSlug/billing'
      path: '/org/$orgSlug/billing'
      fullPath: '/org/$orgSlug/billing'
      preLoaderRoute: typeof appOrgOrgSlugBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appBillingRoute: appBillingRoute,
  appDashboardRoute: appDashboardRoute,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  publicSplatRoute: publicSplatRoute,
  publicChangelogRoute: publicChangelogRoute,
  publicDemoRoute: publicDemoRoute,
  publicPricingRoute: publicPricingRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  appAdminAnnouncementsRoute: appAdminAnnouncementsRoute,
  appAdminAuditLogsRoute: appAdminAuditLogsRoute,
  appAdminEmailTemplatesRoute: appAdminEmailTemplatesRoute,
  appAdminFeatureFlagsRoute: appAdminFeatureFlagsRoute,
  appAdminHealthRoute: appAdminHealthRoute,
  appAdminSettingsRoute: appAdminSettingsRoute,
  appAdminUsersRoute: appAdminUsersRoute,
  appSettingsApiKeysRoute: appSettingsApiKeysRoute,
  appSettingsConnectedAccountsRoute: appSettingsConnectedAccountsRoute,
  appSettingsLoginHistoryRoute: appSettingsLoginHistoryRoute,
  appSettingsNotificationsRoute: appSettingsNotificationsRoute,
  appSettingsPreferencesRoute: appSettingsPreferencesRoute,
  appSettingsPrivacyRoute: appSettingsPrivacyRoute,
  appSettingsProfileRoute: appSettingsProfileRoute,
  appSettingsSecurityRoute: appSettingsSecurityRoute,
  appSettingsUsageRoute: appSettingsUsageRoute,
  dashboardBillingCancelRoute: dashboardBillingCancelRoute,
  dashboardBillingSuccessRoute: dashboardBillingSuccessRoute,
  appAdminIndexRoute: appAdminIndexRoute,
  appSettingsIndexRoute: appSettingsIndexRoute,
  appOrgOrgSlugBillingRoute: appOrgOrgSlugBillingRoute,
  appOrgOrgSlugSettingsRoute: appOrgOrgSlugSettingsRoute,
  appOrgOrgSlugTeamRoute: appOrgOrgSlugTeamRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
